import { DEFAULT_STATUSES } from '../../TaskNode/constants';
import { getRelevantTasksForProgress } from './decisionProgress';
import { isTaskCompleteForProgress } from './taskCompletion';

/**
 * Campaign progress from completed tasks, including nested campaigns.
 *
 * Excludes tasks on non-selected decision branches. For unmade decisions,
 * the denominator is the longest potential branch (by step count).
 *
 * If a nested sprint hasn't been loaded yet (no tasks array), falls back
 * to its stored progress value.
 *
 * @returns {number} Progress percentage (0-100)
 */
export const calculateProgress = (tasks, statuses = DEFAULT_STATUSES, nestedSprints = [], allSprints = []) => {
  if (!tasks || tasks.length === 0) return 0;

  const { relevantTasks, effectiveTotal } = getRelevantTasksForProgress(tasks);
  if (effectiveTotal === 0) return 0;

  const taskWeight = 1 / effectiveTotal;
  let totalProgress = 0;

  for (const task of relevantTasks) {
    const nestedSprint = task.nestedSprintId
      ? nestedSprints.find(ns => ns.id === task.nestedSprintId)
      : null;

    if (nestedSprint) {
      const nestedTasks = nestedSprint.tasks;
      let nestedProgress;
      if (nestedTasks && nestedTasks.length > 0) {
        const nestedStatuses = nestedSprint.statuses || DEFAULT_STATUSES;
        const grandchildSprints = allSprints.filter(s => s.parentSprintId === nestedSprint.id);
        nestedProgress = calculateProgress(nestedTasks, nestedStatuses, grandchildSprints, allSprints) / 100;
      } else if (nestedTasks && nestedTasks.length === 0) {
        nestedProgress = 0;
      } else {
        nestedProgress = (nestedSprint.progress || 0) / 100;
      }

      totalProgress += nestedProgress * taskWeight;
    } else if (isTaskCompleteForProgress(task, statuses)) {
      totalProgress += taskWeight;
    }
  }

  return Math.round(totalProgress * 100);
};
